import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/displayToggle/styles.scss';export default {
  "displayToggle": "_displayToggle_fsjdw_1",
  "title": "_title_fsjdw_12"
};